import { action } from 'typesafe-actions';

import { TokenDto } from '../../interfaces/Token.dto';
import { SIGNOUT, USER_SIGNED_IN, USER_SIGNED_OUT } from '../constants/authentication.constants';

export const logout = () => action(SIGNOUT);

export const userSignedIn = (token: TokenDto) => action(USER_SIGNED_IN, token);
export const userSignedOut = () => action(USER_SIGNED_OUT);
